/** Чистые правила раздела Ad Account (Sign in with Apple): тексты ошибок,
 *  выбор основной группы, строка-итог экрана выбора. Тесты — vitest. */

export const APPLE_ERROR_TEXT = {
  cancelled: "Authorization was cancelled. Try again when you're ready.",
  expired: "The authorization link expired. Please sign in with Apple again.",
  no_groups:
    "No Campaign Groups available for this Apple ID. Sign in with an Account Admin or Campaign Group Manager account.",
} as const;

export type AppleErrorCode = keyof typeof APPLE_ERROR_TEXT;

export function isAppleError(v: string): v is AppleErrorCode {
  return Object.prototype.hasOwnProperty.call(APPLE_ERROR_TEXT, v);
}

export const appleSteps = [
  { n: 1, t: "Click Sign in with Apple." },
  { n: 2, t: "Sign in with the Apple ID you use for Apple Ads." },
  { n: 3, t: "Choose the access level and click Grant Access. You'll be returned here." },
];

/** Основная группа: выбранная пользователем, если она отмечена, иначе
 *  первая отмеченная в порядке списка. */
export function defaultPrimary(
  order: number[],
  checked: Set<number>,
  chosen: number | null,
): number | null {
  if (chosen != null && checked.has(chosen)) return chosen;
  return order.find((id) => checked.has(id)) ?? null;
}

export function chooserSummary(
  accounts: { asa_org_id: number; name: string }[],
  checked: Set<number>,
  primary: number | null,
): string {
  const n = accounts.filter((a) => checked.has(a.asa_org_id)).length;
  if (n === 0) return "Select at least one Campaign Group";
  const name = accounts.find((a) => a.asa_org_id === primary)?.name ?? "—";
  return `${n} selected · primary: ${name}`;
}
